/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ComplaintTypeResponse, GetComplaintTypesRequest, GetComplaintTypesState } from "store/modules/complaints/types";

const initialState: GetComplaintTypesState = {
    isRequesting: false,
    successPayload: [],
    errors: []
};

const getComplaintTypesSlice = createSlice({
    name: "complaints@getComplaintTypes",
    initialState,
    reducers: {
        getComplaintTypesRequest: (
            state,
            action: PayloadAction<GetComplaintTypesRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getComplaintTypesSuccess: (
            state,
            action: PayloadAction<ComplaintTypeResponse[]>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getComplaintTypesFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.successPayload = [];
            state.errors = action.payload;
        }
    }
});

export const {
    getComplaintTypesRequest,
    getComplaintTypesSuccess,
    getComplaintTypesFailed
} = getComplaintTypesSlice.actions;
export default getComplaintTypesSlice.reducer;
